import React, { Component } from 'react';
import Input from 'Components/Input';
import ClickOutside from 'Components/ClickOutside';

class Autosuggest extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    onhideAutosuggest = (type) => {
        this.setState({
            [type]: false
        });
    }

    render() {
        const { name, inputValue, onChange, type, options, onSelect, displayName, readOnly } = this.props;
        return (
            <>
                <Input
                    name={name}
                    value={inputValue || ''}
                    onChange={(e) => {
                        this.setState({
                            [`show${type}Autosuggest`]: true
                        });
                        onChange(e);
                    }}
                    readOnly={readOnly}
                />
                {
                    (options || []).length > 0 && this.state[`show${type}Autosuggest`] &&
                    <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${type}Autosuggest`)}>
                        <div className="mr-20 col-1 border-light bg-white z-100 pr">
                            {
                                (options && options.length > 0 && options || []).filter((item) => {
                                    return item
                                }).map((item, searchIndex) => {
                                    return (
                                        <div
                                            key={searchIndex}
                                            name={item[displayName]}
                                            className={"flex flex-middle pl-16 ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                            onClick={() => {
                                                onSelect(item);
                                                this.onhideAutosuggest(`show${type}Autosuggest`);
                                            }}
                                        >
                                            {item[displayName]}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </ClickOutside>
                }
            </>
        )
    }
}

export default Autosuggest;